module.exports = __webpack_public_path__ + "img/wechat_code.5e31bddc.jpg";